const carousel = '.dkt-product-slider';
const slide = '.dkt-product-slider__slide';
const slideActive = 'dkt-product-slider__slide--active';
const activeClass = 'dkt-product-slider__thumbnails--active';
const disableClass = 'dkt-product-slider__navigation--disable';
const navLeft = 'js-product-slider__navigation--left';
const navRight = 'js-product-slider__navigation--right';
const thumbnailsImageSel = '.js-thumbnails__image';
const product_slider_delegate_containerSel = '.js-delegated-product_sliders';

const productItemSlider = {
  init() {
    // mini-sliders : navigation arrow management
    function arrowSliderClick(e) {
      e.stopImmediatePropagation();
      const elem = e.target;
      navigationProductHandler(elem);
      // TODO : remove this class .js-product-slider-init, from templates and js files
      if (elem.closest('.js-product-slider-init')) {
        elem.closest('.js-product-slider-init').classList.remove(
          'js-product-slider-init'
        );
      }
    };
    // event delegation : jquery coulde be replaced with with lightweight vanillaJS, if we aim for the right click target
    jQuery(product_slider_delegate_containerSel).on(
      'click',
      '.js-product-slider__navigation',
      arrowSliderClick
    );

    // mini-sliders : thumbnails management
    function manageThumbnails(e) {
      const currTarget = e.currentTarget;
      if (!currTarget.classList.contains(activeClass)) {
        thumbnailHandler(currTarget, '');
        arrowHandler(currTarget);

        const nextThumbIndex = indexChecker(
          currTarget.closest(carousel).querySelectorAll(thumbnailsImageSel),
          currTarget
            .closest(carousel)
            .$('.dkt-product-slider__thumbnails')
            .$(`.${activeClass}`)
        );
        const slides = currTarget.closest(carousel).querySelectorAll(slide);

        for (let i = 0; i < slides.length; i++) {
          if (i === nextThumbIndex) {
            activeSlideHandler(currTarget, slides[i]);
          }
        }
      }
    }

    // event delegation : jQuery coulde be replaced with lightweight vanillaJS, if we aim for the right click target
    jQuery(product_slider_delegate_containerSel).on(
      'click',
      thumbnailsImageSel,
      manageThumbnails
    );

    let touchStart = '';

    const sliderGallery = cube.$$('.dkt-product-slider__gallery');
    sliderGallery.on('touchstart', e => {
      touchStart = e.changedTouches[0].pageX;
    });

    sliderGallery.on('touchend', e => {
      if(touchStart !== e.changedTouches[0].pageX) {
        swipeHandler(e.target, e.changedTouches[0].pageX, touchStart);
      }
    });
  },
};

function navigationProductHandler(elt) {
  if (!elt.classList.contains(disableClass)) {
    const slideActivated = elt.closest(carousel).querySelector('input:checked').parentElement;
    const arrowClassList = elt.classList;

    if (
      arrowClassList.contains(navLeft) &&
      slideActivated.previousElementSibling
    ) {
      activeSlideHandler(elt, slideActivated.previousElementSibling);
      thumbnailHandler(elt, 'previous');
      arrowHandler(elt);
    } else if (
      arrowClassList.contains(navRight) &&
      slideActivated.nextElementSibling
    ) {
      activeSlideHandler(elt, slideActivated.nextElementSibling);
      thumbnailHandler(elt, 'next');
      arrowHandler(elt);
    } else {
      return false;
    }
  }
}

function indexChecker(listOfElement, element) {
  return Array.prototype.indexOf.call(listOfElement, element);
}

function activeSlideHandler(t, nextSlide) {
  t
    .closest(carousel)
    .querySelector(`.${slideActive}`)
    .classList.remove(slideActive);
  nextSlide.classList.add(slideActive);
  const nextSlideInput = nextSlide.querySelector('input');
  if (nextSlideInput) nextSlideInput.checked = true;

  /* Active Sticker */
  const stickerWrapper = nextSlide
    .closest('.dkt-product')
    .$('.dkt-product__sticker .dkt-product__sticker__wrapper');

  if (
    stickerWrapper &&
    nextSlide.dataset.sticker &&
    JSON.parse(nextSlide.dataset.sticker).stickerContents &&
    JSON.parse(nextSlide.dataset.sticker).stickerContents.length > 0
  ) {
    stickerWrapper.innerHTML = '';
    cube.sticker.dynamicStickerHandler(
      JSON.parse(nextSlide.dataset.sticker).stickerContents,
      stickerWrapper
    );
  } else if (
    stickerWrapper &&
    nextSlide.dataset.modelSticker &&
    nextSlide.dataset.modelSticker.trim() !== ''
  ) {
    stickerWrapper.innerHTML = '';
    stickerWrapper.insertAdjacentHTML(
      'afterbegin',
      nextSlide.dataset.modelSticker.trim()
    );
  } else if (stickerWrapper) {
    stickerWrapper.innerHTML = '';
  }

  /* Active availability for leadtime and online availability */
  const availability = nextSlide
    .closest('.dkt-product')
    .$('.js-product__availability');

  // Only update the status if the product is sellable online
  if (availability.dataset.sellableOnline === 'true') {
    if (!availability.$('.dkt-product__availability')) {
      // wrapper doesn't always need to be in the dom on page load
      // We add it if it's not
      availability.insertAdjacentHTML(
        'afterbegin',
        '<span class="dkt-product__availability"></span>'
      );
    }
    const availabilityWrapper = availability.$('.dkt-product__availability');

    // If that model is out of stock, we have to display an unavailable message :
    if (nextSlide.dataset.available === 'false') {
      availabilityWrapper.classList.remove('dkt-product__leadtime');
      availabilityWrapper.classList.add('dkt-product__not-available');
      availabilityWrapper.textContent = availability.dataset.availability;
    } else {
      // If that model is in stock :
      availabilityWrapper.classList.remove('dkt-product__not-available');
      availabilityWrapper.classList.add('dkt-product__leadtime');

      let leadTimeTodisplay = '';
      let defaultLeadTimeText = '';

      // this is to prevent visual jump when you get from "some infos" to "no info"
      if (availabilityWrapper.textContent !== '') {
        defaultLeadTimeText = String.fromCharCode(160); // = &nbsp;
      }

      // We add leadtime info if we have it...
      if (nextSlide.dataset.leadtime)
        // ...at model level,
        leadTimeTodisplay = nextSlide.dataset.leadtime;
      else if (availability.dataset.leadtime)
        // ..., if not : at product level...
        leadTimeTodisplay = availability.dataset.leadtime; // ..., if neither : we add default text ('' or '&nbsp;')
      else leadTimeTodisplay = defaultLeadTimeText;

      availabilityWrapper.innerHTML = leadTimeTodisplay;
    }
    const storeAvailability = nextSlide
      .closest('.dkt-product')
      .$('.js-product__store-availability');

    const storeAvailabilityWrapper = storeAvailability.$(
      '.dkt-product__store-availability'
    );
    if (nextSlide.dataset.storeAvailable === 'true') {
      storeAvailabilityWrapper.textContent =
        storeAvailability.dataset.storeAvailability;
      storeAvailabilityWrapper.classList.remove('dkt-product__store-availability--unavailable');
    } else if (storeAvailability.dataset.selectedStoreName !== "" ) {
      storeAvailabilityWrapper.textContent = storeAvailability.dataset.storeNonAvailability;
      storeAvailabilityWrapper.classList.add('dkt-product__store-availability--unavailable');
    }
  }
}

function swipeHandler(t, x, startX) {
  const tSlide = t.closest(slide);
  if (x > (startX + 60) && tSlide.previousElementSibling) {
    activeSlideHandler(t, tSlide.previousElementSibling);
    thumbnailHandler(t, 'previous');
    arrowHandler(t);
  } else if (x < (startX - 60) && tSlide.nextElementSibling) {
    activeSlideHandler(t, tSlide.nextElementSibling);
    thumbnailHandler(t, 'next');
    arrowHandler(t);
  }
}

function thumbnailHandler(t, prevOrNext) {
  const thumbnails = t
    .closest(carousel)
    .querySelector('.dkt-product-slider__thumbnails');

  if (
    thumbnails && thumbnails.querySelector('.dkt-product-slider__thumbnails-slide-wrapper')
  ) {
    const currentThumb = thumbnails.querySelector(`.${activeClass}`);
    const thumbList = thumbnails.querySelectorAll(thumbnailsImageSel);
    let thumbToactivate;
    let widthOfElt;
    let eltIndex;

    if (prevOrNext === 'previous') {
      thumbToactivate = currentThumb.previousElementSibling;
      activeThumbnailHandler(currentThumb.previousElementSibling, currentThumb);
    } else if (prevOrNext === 'next') {
      thumbToactivate = currentThumb.nextElementSibling;
      activeThumbnailHandler(currentThumb.nextElementSibling, currentThumb);
    } else {
      thumbToactivate = t;
      activeThumbnailHandler(
        t,
        t.parentElement.querySelector(`.${activeClass}`)
      );
    }
    eltIndex = indexChecker(thumbList, thumbToactivate);
    if (thumbList.length > 0) {
      for (let i = 0; i < thumbList.length; i++) {
        if (thumbList.length - 3 >= eltIndex && eltIndex === i) {
          widthOfElt = thumbList[i].offsetWidth + 10;
          thumbToactivate.parentElement.style.left = `${-widthOfElt * i}px`;
        }
      }
    }

    let currentProductId = null;
    let currentModelId = null;

    t.dataset.id
      ? (currentProductId = t.dataset.id)
      : (currentProductId = t.closest(carousel).querySelector(`.${activeClass}`)
        .dataset.id);
    t.dataset.mcode
      ? (currentModelId = t.dataset.mcode)
      : (currentModelId = t.closest(carousel).querySelector(`.${activeClass}`)
        .dataset.mcode);

    cube.event.send('modelInformation:caller', {
      productId: currentProductId,
      modelId: currentModelId,
      priceNode: t.closest('.dkt-product').$('.dkt-price'),
    });

    if (cube.config.feature_useSkuDisplayName === 'true') {
      cube.updateModelNameDisplay(
        cube.$(`[data-reference-id="${currentModelId}"] img`),
        cube
          .$(`[data-reference-id="${currentModelId}"] img`)
          .closest('.dkt-product')
          .$('.dkt-product__title')
      );
    }
  }
}

function activeThumbnailHandler(thumbnail, previousThumbnail) {
  if (!thumbnail.classList.contains(activeClass)) {
    thumbnail.classList.add(activeClass);
    previousThumbnail.classList.remove(activeClass);
  }
}

function arrowHandler(t) {
  const slider = t.closest(carousel);
  const navLeftElt = slider.querySelector(`.${navLeft}`);
  const navRightElt = slider.querySelector(`.${navRight}`);
  let list;
  let currentActive;

  if (t.closest(carousel).querySelectorAll(thumbnailsImageSel).length > 0) {
    list = slider.querySelectorAll(thumbnailsImageSel);
    currentActive = slider.querySelector(`.${activeClass}`);
  } else {
    list = slider.querySelectorAll(slide);
    currentActive = slider.querySelector(`.${slideActive}`);
  }
  const eltIndex = indexChecker(list, currentActive);

  if(navLeftElt && navRightElt) {
    if (eltIndex + 1 === list.length) {
      navLeftElt.classList.remove(disableClass);
      navRightElt.classList.add(disableClass);
    } else if (eltIndex === 0) {
      navLeftElt.classList.add(disableClass);
      navRightElt.classList.remove(disableClass);
    } else if (eltIndex > 0) {
      navRightElt.classList.remove(disableClass);
      navLeftElt.classList.remove(disableClass);
    }
  }
  cube.event.send('product-item-swipe', {
    element: slider,
    index: currentActive,
  });
}

module.exports = productItemSlider;



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-product-item.js